import { WALLET_UPDATE_WALLET_STORAGE_REQUEST } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';

// TODO: Add unit tests
const removeHideReceiptListing = _ref => {
  let {
    types
  } = _ref;
  return payload => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;

    // Store updated payments values
    eventBus.emit(WALLET_UPDATE_WALLET_STORAGE_REQUEST, {
      currentPaymentsInfo: {
        ...paymentsInfo
      },
      payload,
      actionCode: 'removeHideReceiptListing'
    });
    dispatch({
      type: types.REMOVE_HIDE_RECEIPT_LISTING,
      payload
    });
  };
};
export default removeHideReceiptListing;